<template>
    <div
        class="py-6 lg:py-10 flex justify-center title-paragraph bg-grey-light"
        v-observe-visibility="visibilityChanged"
    >
        <div
            class="p-6 px-6 lg:px-12 mx-6 lg:mx-12 container text-center flex flex-col items-center bg-white w-full lg:w-3/5"
            :class="['testimonial-' + devise.metadata.instance_id]"
        >
            <div
                v-html="devise.testimonial.text"
                class="pt-4 wysiwyg testimonial"
            ></div>
        </div>
    </div>
</template>

<script>
import anime from "animejs/lib/anime.es.js";

export default {
    data() {
        return {
            isVisible: false
        };
    },

    mounted() {
        anime({
            targets: [".testimonial-" + this.devise.metadata.instance_id],
            translateX: 5000,
            opacity: 0,
            duration: 2000
        });
    },

    methods: {
        visibilityChanged(isVisible) {
            this.isVisible = isVisible;

            if (this.isVisible) {
                anime({
                    targets: [
                        ".testimonial-" + this.devise.metadata.instance_id
                    ],
                    translateX: 0,
                    opacity: 1,
                    duration: 3000,
                    easing: "easeOutExpo",
                    delay: anime.stagger(200)
                });
            } else {
                anime({
                    targets: [
                        ".testimonial-" + this.devise.metadata.instance_id
                    ],
                    translateX: 5000,
                    opacity: 0,
                    duration: 2000
                });
            }
        }
    }
};
</script>
